// src/components/Footer.js
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { joinCommunity } from "../services/community.api";

function Footer() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [openAbout, setOpenAbout] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [showLocations, setShowLocations] = useState(false);
  
  const BRANCHES = [
  {
    en: "North Lebanon – Mejdlaya",
    ar: "شمال لبنان - مجدليا",
    url: "https://maps.google.com/?q=34.410492,35.882248",
  },
  {
    en: "Akkar – Andket",
    ar: "عكار - عندقت",
    url: "https://maps.google.com/?q=34.588032,36.300068",
  },
  {
    en: "North Lebanon – Kobbe",
    ar: "شمال لبنان - القبة",
    url: "https://maps.google.com/?q=34.438076,35.857723",
  },
  {
    en: "North Lebanon – Jabal Mohsen",
    ar: "شمال لبنان - جبل محسن",
    url: "https://maps.google.com/?q=34.443188,35.853664",
  },
  {
    en: "Akkar – Al Hissa",
    ar: "عكار - الحيصة",
    url: "https://maps.google.com/?q=34.584431,36.053406",
  },
];


  const SOCIAL_LINKS = [
  {
    icon: "facebook",
    url: "https://www.facebook.com/share/16nCzkR4Xn/?mibextid=wwXIfr",
  },
  {
    icon: "instagram",
    url: "https://www.instagram.com/lions_110?igsh=MXM1OXVodWpuYjNqdQ==",
  },
  {
    icon: "location-pin",
    url: "https://goo.gl/maps/Yj4h1fDAff434HAu5",
  },
  {
  icon: "whatsapp",
  url: "https://wa.me/96170203205",
  label: "1",
},
{
  icon: "whatsapp",
  url: "https://wa.me/96181220255",
  label: "2",
},
{
  icon: "whatsapp",
  url: "https://wa.me/96181456574",
  type: "wholesale",
},
];


  const AGENCY_EMAIL = "mailto:info@novagrowthmedia.com";

  const TEXT = {
    EN: {
      subscribe:
        "Join our tactical circle for exclusive drops and mission-ready gear.",
      about: "ABOUT",
      aboutText:
        "LIONS is a premium tactical & hunting destination built for professionals, outdoor athletes, and defenders.",
      help: "CUSTOMER CARE",
      helpText:
        "For gear guidance, orders, or delivery support, our team is ready daily from 10 AM to 7 PM.",
      join: "STAY CONNECTED",
      emailPlaceholder: "Your email address",
      signup: "JOIN",
      rights: "All Rights Reserved",
    },
    AR: {
      subscribe:
        "انضم إلى مجتمع لايونز للحصول على أحدث المعدات والعروض الحصرية.",
      about: "من نحن",
      aboutText:
        "لايونز هو متجر تكتيكي مخصص للمحترفين وهواة الصيد والميدان.",
      help: "خدمة الزبائن",
      helpText:
        "للاستفسارات والمساعدة، فريقنا جاهز يوميًا من 10 صباحًا حتى 7 مساءً.",
      join: "ابقَ على تواصل",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      signup: "اشترك",
      rights: "جميع الحقوق محفوظة",
    },
  };

  const t = TEXT[lang];

  const isValidEmail = (v) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const handleJoin = async () => {
    if (!isValidEmail(email)) {
      setToast({
        type: "error",
        message:
          lang === "EN"
            ? "Enter a valid email address"
            : "يرجى إدخال بريد إلكتروني صحيح",
      });
      return;
    }

    try {
      setLoading(true);
      await joinCommunity(email);
      setEmail("");
      setToast({
        type: "success",
        message:
          lang === "EN"
            ? "Welcome to the Lions community 🦁"
            : "مرحبًا بك في مجتمع لايونز 🦁",
      });
    } catch {
      setToast({
        type: "error",
        message:
          lang === "EN"
            ? "Something went wrong"
            : "حدث خطأ ما",
      });
    } finally {
      setLoading(false);
      setTimeout(() => setToast(null), 3000);
    }
  };

  return (
    <footer
      dir={lang === "AR" ? "rtl" : "ltr"}
      className="
        w-full bg-[#0F1A12]
        pt-10 pb-12 px-6
        md:px-14 lg:px-24 xl:px-40
        border-t border-[#2E5A2A]/40
        relative overflow-hidden
        text-[#D6E5D9]
      "
    >
      {/* HUD GRID */}
      <div className="absolute inset-0 hud-grid opacity-10 pointer-events-none" />

      {/* MOBILE */}
      <div className="relative z-10 md:hidden">
        <p className="text-sm leading-6 mb-6 text-[#C9D8CC]">
          {t.subscribe}
        </p>

        {[{
          k: openAbout,
          s: setOpenAbout,
          t: t.about,
          d: t.aboutText,
        },
        {
          k: openHelp,
          s: setOpenHelp,
          t: t.help,
          d: t.helpText,
        }].map((sec, i) => (
          <div key={i}>
            <div
              className="
                py-3
                border-t border-[#2E5A2A]/40
                flex justify-between
                font-semibold tracking-wide
                text-[#E3EFE7]
              "
              onClick={() => sec.s(!sec.k)}
            >
              <span>{sec.t}</span>
              <span>{sec.k ? "−" : "+"}</span>
            </div>
            {sec.k && (
              <p className="text-xs leading-5 text-[#B8C9BC] pb-3">
                {sec.d}
              </p>
            )}
          </div>
        ))}

        <button
          onClick={() => navigate("/contact")}
          className="
            w-full mt-4 py-3
            bg-[#2E5A2A]
            text-white
            font-semibold tracking-wide
            rounded-md
            hover:brightness-110
            transition
          "
        >
          {lang === "EN" ? "Contact / Messages" : "تواصل معنا"}
        </button>

        <h3 className="mt-6 font-bold tracking-widest text-[#9FB39C]">
          {t.join}
        </h3>

        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.emailPlaceholder}
          className="
            w-full mt-4 px-4 py-3
            bg-[#121F17]
            border border-[#2E5A2A]/50
            rounded-md
            text-[#E3EFE7]
            placeholder:text-[#8FA39A]
          "
        />

        <button
          onClick={handleJoin}
          disabled={loading}
          className="
            w-full mt-3 py-3
            bg-[#2E5A2A]
            text-white
            font-semibold tracking-wide
            rounded-md
            hover:brightness-110
            transition
          "
        >
          {loading ? "..." : t.signup}
        </button>

        <div className="flex items-center gap-4 mt-6 flex-wrap">
  {/* 🔵 CIRCULAR ICONS ONLY */}
  <div className="flex gap-4">
    {SOCIAL_LINKS.filter(i => i.type !== "wholesale").map((item, i) =>
  item.icon === "location-pin" ? (
    <button
      key={`location-${i}`}
      onClick={() => setShowLocations(true)}
      className="
        relative
        w-10 h-10
        rounded-full
        bg-white/10
        border border-white/15
        flex items-center justify-center
        hover:bg-white/20
        transition
        flex-shrink-0
      "
    >
      <img
        src={`/icons/${item.icon}.svg`}
        alt={item.icon}
        className="w-5 h-5 opacity-90"
      />
    </button>
  ) : (
    <a
      key={`${item.icon}-${i}`}
      href={item.url}
      target="_blank"
      rel="noreferrer"
      className="
        relative
        w-10 h-10
        rounded-full
        bg-white/10
        border border-white/15
        flex items-center justify-center
        hover:bg-white/20
        transition
        flex-shrink-0
      "
    >
      <img
        src={`/icons/${item.icon}.svg`}
        alt={item.icon}
        className="w-5 h-5 opacity-90"
      />

      {item.label && (
        <span
          className="
            absolute -top-1 -right-1
            w-5 h-5
            rounded-full
            bg-[#2E5A2A]
            text-white
            text-[10px]
            flex items-center justify-center
            font-bold
          "
        >
          {item.label}
        </span>
      )}
    </a>
  )
)}
  </div>

  {/* 🟢 WHOLESALE BUTTON */}
  {SOCIAL_LINKS.find(i => i.type === "wholesale") && (
    <a
      href={SOCIAL_LINKS.find(i => i.type === "wholesale").url}
      target="_blank"
      rel="noreferrer"
      className="
        flex items-center gap-2
        px-4 py-2
        rounded-md
        bg-white/10
        border border-white/15
        hover:bg-white/20
        transition
        text-xs font-semibold
        text-[#E3EFE7]
        whitespace-nowrap
      "
    >
      <img
        src="/icons/whatsapp.svg"
        alt="whatsapp"
        className="w-5 h-5"
      />
      <span>
        {lang === "EN" ? "Wholesale Orders" : "طلبات الجملة"}
      </span>
    </a>
  )}
</div>


        <p className="text-xs mt-6 text-[#8FA39A]">
          © {new Date().getFullYear()} — {t.rights}
        </p>

        <a
          href={AGENCY_EMAIL}
          className="underline text-xs text-[#8FA39A] hover:text-[#C9D8CC]"
        >
          NOVA Growth Media
        </a>
      </div>

{/* DESKTOP */}
<div className="hidden md:grid relative z-10 grid-cols-3 gap-12 text-sm">
  {/* COLUMN 1 — BRAND */}
  <div>
    <p className="leading-6 text-[#C9D8CC] mb-4">
      {t.subscribe}
    </p>

    <p className="text-xs text-[#8FA39A] mt-6">
      © {new Date().getFullYear()} — {t.rights}
    </p>

    <a
      href={AGENCY_EMAIL}
      className="block underline text-xs mt-2 text-[#8FA39A] hover:text-[#C9D8CC]"
    >
      NOVA Growth Media
    </a>
  </div>

  {/* COLUMN 2 — ABOUT / HELP */}
  <div className="space-y-4">
    <div>
      <h4 className="font-semibold tracking-wide mb-2 text-[#E3EFE7]">
        {t.about}
      </h4>
      <p className="text-xs leading-5 text-[#B8C9BC]">
        {t.aboutText}
      </p>
    </div>

    <div>
      <h4 className="font-semibold tracking-wide mb-2 text-[#E3EFE7]">
        {t.help}
      </h4>
      <p className="text-xs leading-5 text-[#B8C9BC]">
        {t.helpText}
      </p>
    </div>

    <button
      onClick={() => navigate("/contact")}
      className="
        mt-3 inline-block
        px-4 py-2
        bg-[#2E5A2A]
        text-white text-xs font-semibold
        rounded-md
        hover:brightness-110
        transition
      "
    >
      {lang === "EN" ? "Contact / Messages" : "تواصل معنا"}
    </button>
  </div>

  {/* COLUMN 3 — NEWSLETTER */}
  <div>
    <h4 className="font-bold tracking-widest text-[#9FB39C] mb-3">
      {t.join}
    </h4>

    <input
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder={t.emailPlaceholder}
      className="
        w-full px-4 py-3
        bg-[#121F17]
        border border-[#2E5A2A]/50
        rounded-md
        text-[#E3EFE7]
        placeholder:text-[#8FA39A]
      "
    />

    <button
      onClick={handleJoin}
      disabled={loading}
      className="
        w-full mt-3 py-3
        bg-[#2E5A2A]
        text-white
        font-semibold tracking-wide
        rounded-md
        hover:brightness-110
        transition
      "
    >
      {loading ? "..." : t.signup}
    </button>

    <div className="flex gap-4 mt-6">
      <div className="flex gap-4 mt-6">
  {SOCIAL_LINKS.map((item, i) => {
  // 🟢 WHOLESALE BUTTON (UNCHANGED)
  if (item.type === "wholesale") {
    return (
      <a
        key={`wholesale-${i}`}
        href={item.url}
        target="_blank"
        rel="noreferrer"
        className="
          flex items-center gap-2
          px-4 py-2
          rounded-md
          bg-white/10
          border border-white/15
          hover:bg-white/20
          transition
          text-xs font-semibold
          text-[#E3EFE7]
        "
      >
        <img
          src="/icons/whatsapp.svg"
          alt="whatsapp"
          className="w-5 h-5"
        />
        <span>
          {lang === "EN" ? "Wholesale Orders" : "طلبات الجملة"}
        </span>
      </a>
    );
  }

  // 📍 LOCATION ICON → OPEN OVERLAY
  if (item.icon === "location-pin") {
    return (
      <button
        key={`location-${i}`}
        onClick={() => setShowLocations(true)}
        className="
          relative
          w-10 h-10
          rounded-full
          bg-white/10
          border border-white/15
          flex items-center justify-center
          hover:bg-white/20
          transition
        "
      >
        <img
          src={`/icons/${item.icon}.svg`}
          alt={item.icon}
          className="w-5 h-5 opacity-90"
        />
      </button>
    );
  }

  // 🔵 NORMAL ICONS (FACEBOOK, INSTAGRAM, WHATSAPP 1 & 2)
  return (
    <a
      key={`${item.icon}-${i}`}
      href={item.url}
      target="_blank"
      rel="noreferrer"
      className="
        relative
        w-10 h-10
        rounded-full
        bg-white/10
        border border-white/15
        flex items-center justify-center
        hover:bg-white/20
        transition
      "
    >
      <img
        src={`/icons/${item.icon}.svg`}
        alt={item.icon}
        className="w-5 h-5 opacity-90"
      />

      {item.label && (
        <span
          className="
            absolute -top-1 -right-1
            w-5 h-5
            rounded-full
            bg-[#2E5A2A]
            text-white
            text-[10px]
            flex items-center justify-center
            font-bold
          "
        >
          {item.label}
        </span>
      )}
    </a>
  );
})}

</div>

    </div>
  </div>
</div>

      {/* TOAST */}
      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
          <div
            className={`px-6 py-3 rounded-full font-semibold
              ${
                toast.type === "success"
                  ? "bg-[#2E5A2A] text-white"
                  : "bg-red-600 text-white"
              }`}
          >
            {toast.message}
          </div>
        </div>
      )}

     {showLocations && (
  <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
    <div className="bg-[#0F1A12] w-[90%] max-w-md rounded-2xl border border-[#2E5A2A]/40 p-6">
      
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-bold text-lg text-[#E3EFE7]">
          {lang === "EN" ? "Our Branches" : "فروعنا"}
        </h2>
        <button
          onClick={() => setShowLocations(false)}
          className="text-[#9FB39C] hover:text-white text-xl"
        >
          ×
        </button>
      </div>

      {/* LIST */}
      <div className="space-y-3">
        {BRANCHES.map((b, i) => (
          <a
            key={i}
            href={b.url}
            target="_blank"
            rel="noreferrer"
            className="
              block
              px-4 py-3
              rounded-md
              bg-white/5
              border border-white/10
              hover:bg-white/10
              transition
              text-sm
            "
          >
            {lang === "EN" ? b.en : b.ar}
          </a>
        ))}
      </div>
    </div>
  </div>
)}

    </footer>
  );
}

export default Footer;
